export const breakpoints = {
  100: {
    slidesPerView: 1,
  },
  260: {
    slidesPerView: 1.25,
  },
  320: {
    slidesPerView: 1.5,
  },
  420: {
    slidesPerView: 2,
  },
  500: {
    slidesPerView: 2.25,
  },
  560: {
    slidesPerView: 2.5,
  },
  640: {
    slidesPerView: 3,
  },
  768: {
    slidesPerView: 2,
  },
  850: {
    slidesPerView: 2.25,
  },
  950: {
    slidesPerView: 2.5,
  },
  1024: {
    slidesPerView: 3,
  },
};
